document.addEventListener("DOMContentLoaded", () => {
	const TRANSITION_MS = 300;
	const preloadSet = new Set();

	// Helper function to parse srcset strings into array of URLs
	function parseSrcset(srcsetStr) {
		if (!srcsetStr) return [];

		// Split by commas and extract the URL part (before the width descriptor)
		return srcsetStr
			.split(",")
			.map((entry) => entry.trim().split(" ")[0])
			.filter((url) => url);
	}

	function preloadImage(url) {
		if (!url || preloadSet.has(url)) return;

		new Image().src = url;
		preloadSet.add(url);
	}

	function preloadThumbnailImages(el) {
		const sec = el.dataset.thumbnailSecondary || null;
		preloadImage(sec);

		// Preload combined listing featured images
		const featuredImage = el.dataset.combinedListingFeaturedImage || null;
		preloadImage(featuredImage);

		// Preload all srcset images for combined listings
		const featuredImageSrcset =
			el.dataset.combinedListingFeaturedImageSrcset || null;
		if (featuredImageSrcset) {
			const srcsetUrls = parseSrcset(featuredImageSrcset);
			srcsetUrls.forEach(preloadImage);
		}
	}

	function getMainGalleryImage() {
		return document.querySelector(".product-gallery__media.is-initial img");
	}

	function rememberOriginalGalleryImage(imgEl) {
		if (!imgEl) return;

		if (
			!Object.prototype.hasOwnProperty.call(
				imgEl.dataset,
				"combinedListingOriginalSrc"
			)
		) {
			imgEl.dataset.combinedListingOriginalSrc = imgEl.src || "";
			imgEl.dataset.combinedListingOriginalSrcset = imgEl.srcset || "";
		}
	}

	// Helper function to handle image swapping with fade transition
	function swapWithFade(imgEl, newSrc, newSrcset) {
		if (!imgEl || !newSrc) return;

		imgEl.classList.add("transitioning");
		setTimeout(() => {
			imgEl.src = newSrc;
			if (newSrcset) {
				imgEl.srcset = newSrcset;
			} else {
				imgEl.removeAttribute("srcset");
			}
			void imgEl.offsetWidth;
			imgEl.classList.remove("transitioning");
		}, TRANSITION_MS);
	}

	function bindCombinedListingPreview(swatch) {
		if (swatch.dataset.combinedListingPreviewBound === "true") return;

		swatch.dataset.combinedListingPreviewBound = "true";

		swatch.addEventListener("mouseenter", () => {
			const featuredImage = swatch.dataset.combinedListingFeaturedImage;
			if (!featuredImage) return;

			const mainImg = getMainGalleryImage();
			if (!mainImg) return;

			rememberOriginalGalleryImage(mainImg);
			swapWithFade(
				mainImg,
				featuredImage,
				swatch.dataset.combinedListingFeaturedImageSrcset
			);
		});

		swatch.addEventListener("mouseleave", () => {
			const mainImg = getMainGalleryImage();
			if (!mainImg) return;

			const originalSrc = mainImg.dataset.combinedListingOriginalSrc;
			if (!originalSrc) return;

			swapWithFade(
				mainImg,
				originalSrc,
				mainImg.dataset.combinedListingOriginalSrcset || ""
			);
		});
	}

	/**
	 * Ensure hidden Slick slides are not keyboard-focusable.
	 * Slides that Slick marks with aria-hidden="true" will have all focusable
	 * descendants removed from the tab order (tabindex="-1").
	 * Visible slides restore their original tabindex (or remove the attribute).
	 */
	function updateSlickSlideAccessibility($slider) {
		if (!$slider || !$slider.length) return;

		const $slides = $slider.find(".slick-slide");
		$slides.each(function () {
			const $slide = $(this);
			const isHidden = $slide.attr("aria-hidden") === "true";

			// Also manage tabindex on the slide element itself, since Slick may
			// set tabindex on .slick-slide for drag/focus handling.
			const slideHasStored =
				$slide.data("original-tabindex") !== undefined;
			if (!slideHasStored) {
				$slide.data("original-tabindex", $slide.attr("tabindex"));
			}

			if (isHidden) {
				$slide.attr("tabindex", "-1");
			} else {
				const originalSlideTabindex = $slide.data("original-tabindex");
				if (
					originalSlideTabindex === undefined ||
					originalSlideTabindex === null ||
					originalSlideTabindex === ""
				) {
					$slide.removeAttr("tabindex");
				} else {
					$slide.attr("tabindex", originalSlideTabindex);
				}
			}

			const $focusables = $slide.find(
				"a, button, input, select, textarea, [tabindex]"
			);

			$focusables.each(function () {
				const $el = $(this);
				const hasStored = $el.data("original-tabindex") !== undefined;

				if (!hasStored) {
					$el.data("original-tabindex", $el.attr("tabindex"));
				}

				if (isHidden) {
					// Hidden slide: remove from tab order
					$el.attr("tabindex", "-1");
				} else {
					// Visible slide: restore previous tabindex or remove attribute
					const original = $el.data("original-tabindex");
					if (original === undefined || original === null || original === "") {
						$el.removeAttr("tabindex");
					} else {
						$el.attr("tabindex", original);
					}
				}
			});
		});
	}

	function initThumbnailGroup(group) {
		const thumbnails = group.querySelectorAll(".thumbnail-swatch");
		if (!thumbnails.length) return;

		thumbnails.forEach((thumbnail) => {
			preloadThumbnailImages(thumbnail);
			bindCombinedListingPreview(thumbnail);
		});

		const $group = $(group);
		const $extraItems = $group.find(
			".variant-picker__option-value:nth-child(n+4)"
		);

		if (thumbnails.length > 4) {
			if (!$group.hasClass("slick-initialized")) {
				// Attach handlers before initializing Slick so "init" is captured
				$group.on("init reInit afterChange", function () {
					updateSlickSlideAccessibility($group);
				});

				$group.slick({
					slidesToShow: 4.25,
					slidesToScroll: 4,
					arrows: false,
					dots: true,
					infinite: false,
					centerMode: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3.25,
								slidesToScroll: 3,
							},
						},
					],
				});

				// Run once in case Slick has already applied aria-hidden states
				updateSlickSlideAccessibility($group);
			} else {
				updateSlickSlideAccessibility($group);
			}

			$extraItems.show();

			//go to the slide whos child has the class .thumbnail-swatch.is-selected
			const selectedSlide = $group
				.find(".variant-picker__option-value .thumbnail-swatch.is-selected")
				.closest(".variant-picker__option-value");
			if (selectedSlide.length) {
				const index = $(selectedSlide).index();
				$group.slick("slickGoTo", index);
			}
		} else {
			$extraItems.show();
		}
	}

	// Create slider for variant thumbnails if over 4
	window.initThumbnails = function () {
		document
			.querySelectorAll(".variant-picker__option-values")
			.forEach(initThumbnailGroup);
	};
	initThumbnails();

	/**
	 * WCAG 2.1 A - 1.3.1 Accessibility Fix
	 * Ensures all <li> elements are properly wrapped in <ul> or <ol> containers
	 * This fixes semantic structure issues where list items are rendered outside of list containers
	 */
	function fixOrphanedListItems() {
		// Find all <li> elements in the document
		const allListItems = document.querySelectorAll('li');
		
		allListItems.forEach((li) => {
			// Skip <li> inside Slick carousels: Slick moves slides into .slick-track (a div),
			// so they become "orphaned" by structure, but wrapping them would break the carousel.
			if (li.closest('.slick-track, .slick-initialized')) {
				return;
			}

			const parent = li.parentElement;
			
			// Check if the parent is NOT a <ul> or <ol>
			if (parent && parent.tagName !== 'UL' && parent.tagName !== 'OL') {
				// Check if this <li> is already part of a group we're processing
				if (li.dataset.fixedOrphan === 'true') {
					return;
				}
				
				// Find all consecutive orphaned <li> siblings
				const orphanedItems = [];
				let current = li;
				
				// Collect previous siblings
				while (current.previousElementSibling && 
				       current.previousElementSibling.tagName === 'LI' &&
				       current.previousElementSibling.parentElement === parent &&
				       !current.previousElementSibling.dataset.fixedOrphan) {
					current = current.previousElementSibling;
				}
				
				// Start from the first orphaned <li>
				let firstOrphan = current;
				
				// Collect all consecutive orphaned <li> elements
				while (current && 
				       current.tagName === 'LI' && 
				       current.parentElement === parent &&
				       !current.dataset.fixedOrphan) {
					orphanedItems.push(current);
					current.dataset.fixedOrphan = 'true';
					current = current.nextElementSibling;
				}
				
				// If we found orphaned items, wrap them in a <ul>
				if (orphanedItems.length > 0) {
					const ul = document.createElement('ul');
					ul.setAttribute('role', 'list');
					
					// Insert the <ul> before the first orphaned <li>
					firstOrphan.parentNode.insertBefore(ul, firstOrphan);
					
					// Move all orphaned items into the <ul>
					orphanedItems.forEach((item) => {
						ul.appendChild(item);
						delete item.dataset.fixedOrphan;
					});
				}
			}
		});
	}

	// Run the fix on page load
	fixOrphanedListItems();

	// Also run after a short delay to catch any dynamically loaded content
	setTimeout(fixOrphanedListItems, 500);

	// Use MutationObserver to fix any dynamically added content
	const observer = new MutationObserver((mutations) => {
		let shouldFix = false;
		
		mutations.forEach((mutation) => {
			if (mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === 1) { // Element node
						// Check if the added node or its children contain <li> elements
						if (node.tagName === 'LI' || 
						    node.querySelector && node.querySelector('li')) {
							shouldFix = true;
						}
					}
				});
			}
		});
		
		if (shouldFix) {
			// Debounce the fix
			clearTimeout(window.orphanFixTimeout);
			window.orphanFixTimeout = setTimeout(fixOrphanedListItems, 100);
		}
	});

	// Observe the entire document for changes
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
});
